import createAsyncActionType from '../../../utilities/createAsyncActionType';

export const GET_WATCHLIST_UPDATE_LOGS = createAsyncActionType('GET_WATCHLIST_UPDATE_LOGS');

export const GET_WATCHLIST_UPDATE_LOGS_COUNT = createAsyncActionType('GET_WATCHLIST_UPDATE_LOGS_COUNT');

export const SET_WATCHLIST_UPDATE_LOGS_PAGE = 'SET_WATCHLIST_UPDATE_LOGS_PAGE';

export const SET_WATCHLIST_UPDATE_LOGS_ITEMS_PER_PAGE = 'SET_WATCHLIST_UPDATE_LOGS_ITEMS_PER_PAGE';



// WEBPACK FOOTER //
// ./src/features/reports/types/watchlistUpdateLogType.js